<template>
  <el-table :data="data" style="width: 100%;" :row-class-name="tableRowClassName" height="calc(100% - 140px)">
    <el-table-column label="序号" type="index" width="50">
    </el-table-column>
    <el-table-column prop="UserCode" label="客户代码" width="80" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="UserName" label="客户名称" width="100" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="ContractNo" label="合约代码" width="80" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="ContractName" label="合约名称" width="120" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="Direction" label="方向" width="80">
      <template slot-scope="scope">
        <span>{{scope.row.Direction | GetDirection}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="PositionEffect" label="开平" width="80">
      <template slot-scope="scope">
        <span>{{scope.row.PositionEffect | PositionEffect}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="Volume" label="成交数量" width="80">
    </el-table-column>
    <el-table-column prop="Commission" label="手续费" width="80">
    </el-table-column>
    <el-table-column prop="Price" label="成交价格" width="80">
      <!-- <template slot-scope="scope">
        <span>{{scope.row.OrderState | GetDelegateOrderStateType}}</span> 
      </template> -->
    </el-table-column>
    <el-table-column prop="TradeDateTime" label="成交时间" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="CloseProfit" label="平仓盈亏" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="LocalMatchNo" label="成交编号" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="ExchangeName" label="交易所名称" :show-overflow-tooltip="true">
    </el-table-column>
    <!-- 查看明细弹窗 -->
  </el-table>
</template>

<script>
import EnumConfig from "../../../assets/js/EnumConfig.js";
export default {
  // 委托表格
  name: "mycapitalT",
  data() {
    return {
      dialogVisible: false,
      obj: {}
    };
  },
  props: ["data"],
  filters: {
    GetDelegateOrderStateType(type) {
      return EnumConfig.GetDelegateOrderStateType(type);
    },
    GetDirection(type) {
      return EnumConfig.GetDirection(type);
    },
    PositionEffect(type) {
      return EnumConfig.PositionEffect(type);
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    handleClick(row) {
      this.dialogVisible = true;
      this.obj = row;
    }
  }
};
</script>

<style scoped>
</style>
 


// WEBPACK FOOTER //
// src/components/selects/mydealDetail/mydealDetailT.vue